import { createReducer } from '@ngrx/store';
import { SimilarResultsState } from '@immosky/types';
import { immerOn } from 'ngrx-immer/store';
import { setSimilarRealEstateObjects } from './similar-results.actions';

export const initialState: SimilarResultsState = {
  results: [],
  // results: [
  //   {
  //     images: [
  //       {
  //         altText: 'Platz zum Spielen und Toben',
  //         url: 'http://api.skynet.immosky.ch/image/watermark/1731447',
  //       },
  //     ],
  //     topImage: {
  //       url: 'http://api.skynet.immosky.ch/image/watermark/1731447',
  //       altText: 'Platz zum Spielen und Toben',
  //     },
  //     location: {
  //       city: 'Oftringen',
  //       postCode: '4665',
  //       coordinates: {
  //         lat: 47.296,
  //         lng: 7.93999,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total: 1300000,
  //     },
  //     floorSpace: 290,
  //     roomCount: '7.5',
  //     title: 'Fast wie im Paradies',
  //     description: 'Fast wie im Paradies',
  //     id: '84441',
  //     contractType: 'buy',
  //     flats: 2,
  //     category: 'house',
  //   },
  //   {
  //     images: [
  //       {
  //         altText:
  //           'Willkommen Zuhause',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1903873',
  //       },
  //       {
  //         altText:
  //           'Sonniger Wohnberreich',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1903811',
  //       },
  //       {
  //         altText:
  //           'Zum wohlfühlen',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1903863',
  //       },
  //       {
  //         altText:
  //           '20.jpg',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1903869',
  //       },
  //       {
  //         altText:
  //           'Ihr eigenes Pradies',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1903867',
  //       },
  //     ],
  //     topImage: {
  //       url:
  //         'http://api.skynet.immosky.ch/image/watermark/1903811',
  //       altText:
  //         'Sonniger Wohnberreich',
  //     },
  //     location: {
  //       city: 'Rothrist',
  //       postCode: '4852',
  //       coordinates: {
  //         lat: 47.3023,
  //         lng: 7.888,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total:
  //         1600000,
  //     },
  //     floorSpace:
  //       240,
  //     roomCount: '6.5',
  //     title: 'In der Ruhe liegt die Kraft',
  //     description: 'In der Ruhe liegt die Kraft',
  //     id: '109405',
  //     contractType: 'buy',
  //     flats: 0,
  //     category: 'house',
  //   },
  //   {
  //     images: [
  //       {
  //         altText:
  //           'Beste Lage',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1871251',
  //       },
  //       {
  //         altText:
  //           'Gemütliches Wohnambiente garantiert',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1804239',
  //       },
  //       {
  //         altText:
  //           'Gemütlicher Wohnbereich',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1871263',
  //       },
  //       {
  //         altText:
  //           'Platz für Ihre Einrichtungsideen',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1871269',
  //       },
  //       {
  //         altText:
  //           'Perfekt für Gourmets',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1804225',
  //       },
  //     ],
  //     topImage: {
  //       url:
  //         'http://api.skynet.immosky.ch/image/watermark/1871251',
  //       altText:
  //         'Beste Lage',
  //     },
  //     location: {
  //       city: 'Holziken',
  //       postCode: '5043',
  //       coordinates: {
  //         lat: 47.3244,
  //         lng: 8.0374,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total:
  //         498000,
  //     },
  //     floorSpace:
  //       83,
  //     roomCount: '3.5',
  //     title: 'RESERVIERT',
  //     description: 'RESERVIERT',
  //     id: '110229',
  //     contractType: 'buy',
  //     flats: 14,
  //     category: 'flat',
  //   },
  //   {
  //     images: [
  //       {
  //         altText:
  //           'Zum Entspannen und Geniessen',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1821239',
  //       },
  //       {
  //         altText:
  //           'Viel Platz für die Familie',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1821243',
  //       },
  //       {
  //         altText:
  //           'Rarität',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1821273',
  //       },
  //       {
  //         altText:
  //           'Ihr Wohntraum mit Garten',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1821261',
  //       },
  //       {
  //         altText:
  //           'Ihr eigenes Gartenparadies',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1821267',
  //       },
  //     ],
  //     topImage: {
  //       url:
  //         'http://api.skynet.immosky.ch/image/watermark/1821239',
  //       altText:
  //         'Zum Entspannen und Geniessen',
  //     },
  //     location: {
  //       city: 'Oftringen',
  //       postCode: '4665',
  //       coordinates: {
  //         lat: 47.302,
  //         lng: 7.94419,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total:
  //         720000,
  //     },
  //     floorSpace:
  //       170,
  //     roomCount: '5.5',
  //     title: 'RESERVIERT',
  //     description: 'RESERVIERT',
  //     id: '113543',
  //     contractType: 'buy',
  //     flats: 0,
  //     category: 'house',
  //   },
  //   {
  //     images: [
  //       {
  //         altText:
  //           'Guter Plan für die Zukunft',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1856441',
  //       },
  //     ],
  //     topImage: {
  //       url:
  //         'http://api.skynet.immosky.ch/image/watermark/1856441',
  //       altText:
  //         'Guter Plan für die Zukunft',
  //     },
  //     location: {
  //       city: 'Holziken',
  //       postCode: '5043',
  //       coordinates: {
  //         lat: 47.3235,
  //         lng: 8.03751,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total:
  //         2650000,
  //     },
  //     floorSpace:
  //       700,
  //     roomCount: '25',
  //     title: 'Gross, grösser, Rendite von über 4%',
  //     description: 'Gross, grösser, Rendite von über 4%',
  //     id: '115099',
  //     contractType: 'buy',
  //     flats: 6,
  //     category: 'income',
  //   },
  //   {
  //     images: [
  //       {
  //         altText:
  //           'Wohnen mit Stil',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1854797',
  //       },
  //       {
  //         altText:
  //           'Moderne Wohlfühloase',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1854787',
  //       },
  //       {
  //         altText:
  //           'Ein Tarum für jeden Hobbykoch',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1854793',
  //       },
  //       {
  //         altText:
  //           'Hier fehlt es an nichts',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1854811',
  //       },
  //       {
  //         altText:
  //           'Kommunizieren Sie mit den Gästen',
  //         url:
  //           'http://api.skynet.immosky.ch/image/watermark/1854795',
  //       },
  //     ],
  //     topImage: {
  //       url:
  //         'http://api.skynet.immosky.ch/image/watermark/1854797',
  //       altText:
  //         'Wohnen mit Stil',
  //     },
  //     location: {
  //       city: 'Oftringen',
  //       postCode: '4665',
  //       coordinates: {
  //         lat: 47.2957,
  //         lng: 7.94124,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total:
  //         945000,
  //     },
  //     floorSpace: 140,
  //     roomCount: '4.5',
  //     title: 'RESERVIERT',
  //     description: 'RESERVIERT',
  //     id: '115393',
  //     contractType: 'buy',
  //     flats: 7,
  //     category: 'flat',
  //   },
  //   {
  //     images: [
  //       {
  //         altText:
  //           'Lichtdurchfluteter Wohnbereich',
  //         url:
  //           'http://api.skynet.immosky.ch/image/base/1896415',
  //       },
  //       {
  //         altText:
  //           'Moderner Wohnbereich',
  //         url:
  //           'http://api.skynet.immosky.ch/image/base/1896409',
  //       },
  //       {
  //         altText:
  //           'Neue Küche',
  //         url:
  //           'http://api.skynet.immosky.ch/image/base/1896495',
  //       },
  //       {
  //         altText:
  //           'Schlafzimmer mit Parkett',
  //         url:
  //           'http://api.skynet.immosky.ch/image/base/1896417',
  //       },
  //       {
  //         altText:
  //           'Top Weitsicht',
  //         url:
  //           'http://api.skynet.immosky.ch/image/base/1896423',
  //       },
  //     ],
  //     topImage: {
  //       url:
  //         'http://api.skynet.immosky.ch/image/base/1896415',
  //       altText:
  //         'Lichtdurchfluteter Wohnbereich',
  //     },
  //     location: {
  //       city: 'Unterentfelden',
  //       postCode: '5035',
  //       coordinates: {
  //         lat: 47.3706,
  //         lng: 8.04334,
  //       },
  //     },
  //     priceOnRequest: false,
  //     price: {
  //       rentGross: 0,
  //       total: 415000,
  //     },
  //     floorSpace: 75,
  //     roomCount: '3.5',
  //     title: 'IHR GLÜCK IN GREIFBARER NAEHE',
  //     description: 'IHR GLÜCK IN GREIFBARER NAEHE',
  //     id: '117647',
  //     contractType: 'buy',
  //     flats: 8,
  //     category: 'flat',
  //   },
  // ],
};

export const similarResultsReducer = createReducer(
  initialState,
  immerOn(setSimilarRealEstateObjects, (state, { objects }) => {
    state.results = objects;
  })
);
